import type { AspectRatio, MimeTypes } from '@/payload-types';

export const mimeTypes = {
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.png': 'image/png',
  '.webp': 'image/webp',
} as const satisfies Record<string, MimeTypes>;

export const aspectRatios = {
  PORTRAIT: 'aspect-portrait',
  SQUARE: 'aspect-square',
  VIDEO: 'aspect-video',
} as const satisfies Record<string, AspectRatio>;
